<template>
  <!-- Header Section -->
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">{{ $t("navigations.real time data alert") }}</h2>
    </div>
    <!-- <div class="text-end col-lg-4  align-self-center">
            <button class="btn btn-sm btn-outline-secondary me-1 py-1">
                <i class="fa fa-printer"></i> Print Report
            </button>
            <button class="btn btn-sm btn-primary py-1">
                <i class="fa fa-database-check"></i> Export Data
            </button>
        </div> -->
  </div>

  <!-- Summary Cards -->
  <div class="wrapper wrapper-content">
    <div class="row mb-2">
      <div class="col-md-3 px-1">
        <div class="card h-100 border-bottom border-2 border-primary">
          <div class="card-body p-0">
            <div class="d-flex align-items-center">
              <div class="bg-primary bg-opacity-10 p-3 rounded-two me-3">
                <i class="fa fa-users text-white fs-4"></i>
              </div>
                <div
                class="card-body py-1" 
                @click="onTotalSubjects" 
                style="cursor: pointer;">
                <h5 class="card-title mb-0">
                  {{ $t("navigations.total subjects") }}
                </h5>
                <p v-if="summary.totalsubjects" class="card-text fs-4 mb-0">
                  {{ summary.totalsubjects }}
                </p>
                <p v-else class="card-text fs-4 mb-0">0</p>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-bottom border-2 border-success">
          <div class="card-body p-0">
            <div class="d-flex align-items-center">
              <div class="bg-success bg-opacity-10 p-3 rounded-two me-3">
                <i class="fa fa-exclamation-triangle text-white fs-4"></i>
              </div>
                <div 
                class="card-body py-1" 
                @click="onActiveAlerts" 
                style="cursor: pointer;">
                <h5 class="card-title mb-0">
                  {{ $t("navigations.active alerts") }}
                </h5>
                <p v-if="summary.activealerts" class="card-text fs-4 mb-0">
                  {{ summary.activealerts }}
                </p>
                <p v-else class="card-text fs-4 mb-0">0</p>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-bottom border-2 border-warning">
          <div class="card-body p-0">
            <div class="d-flex align-items-center">
              <div class="bg-warning bg-opacity-10 p-3 rounded-two me-3">
                <i class="fa fa-exclamation-triangle text-white fs-4"></i>
              </div>
                <div
                class="card-body py-1"  
                @click="onMissingData" 
                style="cursor: pointer;">
                <h5 class="card-title mb-0">{{ $t("navigations.missing data") }}</h5>
                <p v-if="summary.missingdata" class="card-text fs-4 mb-0">
                  {{ summary.missingdata }}
                </p>
                <p v-else class="card-text fs-4 mb-0">0</p>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3 px-1">
        <div class="card h-100 border-bottom border-2 border-danger">
          <div class="card-body p-0">
            <div class="d-flex align-items-center">
              <div class="bg-danger bg-opacity-10 p-3 rounded-two me-3">
                <i class="fa fa-check-square-o text-white fs-4"></i>
              </div>
                <div
                class="card-body py-1"  
                @click="onOutOfRange" 
                style="cursor: pointer;">
                <h5 class="card-title mb-0">{{ $t("navigations.out of range") }}</h5>
                <p v-if="summary.outofrange" 
                class="card-text fs-4 mb-0">
                  {{ summary.outofrange }}
                </p>
                <p v-else class="card-text fs-4 mb-0">0</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- View Alert Details popup ends -->
    <!-- Main Content -->
    <div class="row">
      <!-- Active Alerts -->
      <div class="col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">{{ $t("navigations.subject-wise alerts") }}</h5>
            <!-- <div class="ibox-tools">
              <button class="btn btn-sm btn-outline py-0" @click="refreshAlerts">
                <i class="fa fa-refresh mr-1 text-primary"></i>
              </button>
            </div> -->
          </div>
          <div class="ibox-content">
            <div class="text-center" v-if="showActiveAlertLoading == true">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
              <div>
                {{
                  $t("navigations.please wait while the list is being loaded")
                }}
              </div>
            </div>
            <template v-else>
              <div class="text-center" v-if="summary.activealerts == 0">
                <h4>{{ $t("navigations.no active alerts available") }}</h4>
              </div>

              <div class="table-responsive" v-else   :class="{ 'max-h-400': activeAlerts && activeAlerts.length > 15 }">
                <table class="table table-hover mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("navigations.site code") }}</th>
                      <th>{{ $t("navigations.subject id") }}</th>
                      <th>{{ $t("navigations.type") }}</th>
                      <th>{{ $t("navigations.time elapsed") }}</th>
                      <!-- <th class="text-center">
                        {{ $t("navigations.status") }}
                      </th> -->
                      <th class="text-center">{{ $t("navigations.view") }}</th>
                      <th class="text-center">
                        {{ $t("navigations.alert record") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="alert in activeAlerts"
                      :key="alert.id"
                      class="alert-row"
                    >
                      <td>{{ alert.siteCode }}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          {{ alert.subjectCode }}
                        </div>
                      </td>
                      <td>
                        <span
                          class="alert-type-badge"
                          :class="{
                            'alert-warning':
                              alert.alertConfig.Priority == 'High',
                            'alert-info':
                              alert.alertConfig.Priority == 'Moderate',
                            'alert-danger':
                              alert.alertConfig.Priority == 'Critical',
                          }"
                          >{{ alert.alertConfig.AlertType }}</span
                        >
                      </td>
                      <!-- <td :class="alert.status === 'Pending' ? 'time-elapsed' : ''">
                      {{ alert.status === 'Pending' ? alert.timeElapsed + ' min' : 'Resolved' }}
                    </td> -->
                      <td>{{ relativeTime(alert.createdAt) }}</td>
                      <!-- <td>
                      <span :class="['alert-badge', alert.status === 'Pending' ? 'badge-pending' : 'badge-resolved']">
                        {{ alert.status }}
                      </span>
                    </td> -->
                      <!-- <td class="text-center">
                        <button
                          class="btn btn-sm btn-success mr-1 py-0 w-100"
                          @click="openAlertStatusPopup(alert.id)"
                          :disabled="alert.status === 'Resolved'"
                        >
                          <small>{{
                            alert.status === "Pending" ? "Resolve" : "Resolved"
                          }}</small>
                        </button>
                      </td>  -->
                      <td class="text-center">
                        <i
                          class="fa fa-eye editicon align-middle"
                          @click="viewAlertDetails(alert.id, 'active alerts')"
                        ></i>
                      </td>
                      <td class="text-center">
                        <i
                          class="fa fa-book editicon align-middle"
                          @click="
                            viewAlertRecords(
                              alert.subjectId,
                              alert.subjectCode,
                              alert.siteCode
                            )
                          "
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Recent Alerts -->
      <div class="col-md-6 px-1">
        <div class="ibox mb-2">
          <div class="ibox-title style_2">
            <h5 class="mb-0">{{ $t("navigations.recent alerts") }}</h5>
            <!-- <div class="ibox-tools">
              <button class="btn btn-sm btn-outline py-0" @click="refreshAlerts">
                <i class="fa fa-refresh text-primary"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary py-0 ml-2">
                <i class="fa fa-filter"></i> Filters
              </button>
            </div> -->
          </div>
          <div class="ibox-content">
            <div class="text-center" v-if="showAlertLoading == true">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
              <div>
                {{
                  $t("navigations.please wait while the list is being loaded")
                }}
              </div>
            </div>
            <template v-else>
              <div class="text-center" v-if="alertTotalCount == 0">
                <h4>{{ $t("navigations.no recent alerts available") }}</h4>
              </div>
              <div
                class="alerts"
                :class="{ 'max-h-400': alerts && alerts.length > 4 }"
              >
                <div
                  class="alert d-flex align-items-center"
                  v-for="alert in alerts"
                  :key="alert.id"
                  :class="{
                    'alert-warning': alert.alertConfig.Priority == 'High',
                    'alert-info': alert.alertConfig.Priority == 'Moderate',
                    'alert-danger': alert.alertConfig.Priority == 'Critical',
                  }"
                >
                  <div
                    class="flex-grow-1 cursor-pointer"
                    @click="viewAlertDetails(alert.id, 'recent alerts')"
                  >
                    <div class="d-flex justify-content-between">
                      <strong>{{ alert.alertConfig.AlertType }}</strong>
                      <small class="text-muted">{{
                        formatDateTime(alert.CreatedAt)
                      }}</small>
                    </div>
                    <div>
                      <strong class="mr-2">{{ alert.subjectCode }}</strong>
                      <span
                        class="badge"
                        :class="{
                          'badge-danger':
                            alert.alertConfig.Priority == 'Critical',
                          'alert-badge-primary':
                            alert.alertConfig.Priority == 'Moderate',
                          'badge-warning': alert.alertConfig.Priority == 'High',
                        }"
                        >{{ alert.alertConfig.Priority }}</span
                      >
                      <p class="mb-0">{{ alert.message }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Alert Record -->
  <customModal
    v-if="showAlertRecordModal == true"
    :containermd="true"
    @closeModal="closeSubjectActivityModal()"
  >
    <template #title>
      {{ $t("navigations.alert record") }}
    </template>
    <template #body >
      <div class="text-center" v-if="loadingActivity == true">
        <p class="mb-0">
          {{ $t("navigations.please wait while the list is being loaded") }}
        </p>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>
      <div v-else>
        <div v-if="subjectActivityList.length == 0">
          <h4 class="text-center">{{ $t("navigations.no data available") }}</h4>
        </div>
        <div v-else class="py-1">
          <div class="custom-alert-info alert-info mb-2">
            <h4 class="mb-0">
              {{ $t("navigations.subject") }} -
              {{ subjectCode }} &nbsp;&nbsp;&nbsp;&nbsp;{{
                $t("navigations.site")
              }}
              - {{ siteCode }}
            </h4>
          </div>
          <div class="table-container" :class="{'max-h-400':subjectActivityList.length>15}">
            <table class="data-table">
              <thead>
                <tr>
                  <th style="width: 35%">
                    {{ $t("navigations.type") }}
                  </th>
                  <th style="width: 15%">{{ $t("navigations.alert date") }}</th>
                  <th class="text-center" style="width: 20%">
                    {{ $t("navigations.status") }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ $t("navigations.view") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="activity in subjectActivityList"
                  :key="activity.patientId"
                >
                  <td>
                    <span
                      class="alert-type-badge"
                      :class="{
                        'alert-warning':
                          activity.alertConfig.Priority == 'High',
                        'alert-info':
                          activity.alertConfig.Priority == 'Moderate',
                        'alert-danger':
                          activity.alertConfig.Priority == 'Critical',
                      }"
                      >{{ activity.alertConfig.AlertType }}</span
                    >
                  </td>
                  <td>
                    {{ filterDate(activity.createdAt) }}
                  </td>
                  <td class="text-center">
                    {{ activity.status }}
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye editicon align-middle"
                      @click="viewAlertDetails(activity.id, 'active alerts')"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <customModal
    v-if="showpop == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseSubjectList"
  >
    <template #title>
      {{ $t("navigations.total subjects") }}
    </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.site code") }}</th>
              <th>{{ $t("navigations.subject id") }}</th>
              <th>{{ $t("navigations.type") }}</th>
              <th>{{ $t("navigations.status") }}</th>
              <th>{{ $t("navigations.view") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in subjectList" :key="item.id">
              <td>{{ item.siteCode }}</td>
              <td>{{ item.subjectCode }}</td>
              <td>{{ item.alertConfig && item.alertConfig.AlertType }}</td>
              <td>{{ item.status }}</td>
              <td class="tdtext">
                  <a href="#" class="editicon"><i class="fa fa-eye" @click="viewAlertDetails(item.id, 'active alerts')"></i></a>
                </td>
         
              
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
  <!-- <customModal
    v-if="showpop == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseSubjectList"
  >
    <template #title>
      {{ $t("navigations.total subjects") }}
    </template>
    <template #body>
      <div class="table-responsive mt-2 scrollable">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>{{ $t("navigations.site code") }}</th>
              <th>{{ $t("navigations.subject id") }}</th>
              <th>{{ $t("navigations.type") }}</th>
              <th>{{ $t("navigations.status") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in subjectList" :key="item.id">
              <td>{{ item.siteCode }}</td>
              <td>{{ item.subjectCode }}</td>
              <td>{{ item.alertConfig && item.alertConfig.AlertType }}</td>
              <td>{{ item.status }}</td>
         
              
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal> -->
  <customModal
   v-if="showAlertpopup == true"
   :containersm="true"
   :footerShow="true"
   @closeModal="CloseActiveAlertList"
  >
   <template #title>
    {{ $t("navigations.active alerts") }}
   </template>
   <template #body>
    <div class="table-responsive mt-2 scrollable">
      <table class="table table-bordered table-sm">
       <thead>
        <tr>
          <th>{{ $t("navigations.site code") }}</th>
          <th>{{ $t("navigations.subject id") }}</th>
          <th>{{ $t("navigations.type") }}</th>
          <th>{{ $t("navigations.status") }}</th>
          <th>{{ $t("navigations.view") }}</th>
        </tr>
       </thead>
       <tbody>
        <tr v-for="item in activealerts" :key="item.id">
          <td>{{ item.siteCode }}</td>
          <td>{{ item.subjectCode }}</td>
          <td>{{ item.alertConfig && item.alertConfig.AlertType }}</td>
          <td>{{ item.status }}</td>
          <td class="tdtext">
                  <a href="#" class="editicon"><i class="fa fa-eye"  @click="viewAlertDetails(item.id, 'active alerts')"></i></a>
                </td>
        </tr>
       </tbody>
      </table>
    </div>
   </template>
   <template #footer> </template>
  </customModal>
   <customModal
    v-if="showAlertMissing == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="CloseAlertMissList"
  >
    <template #title>
      {{ $t("navigations.missing data") }}
    </template>
    <template #body>
      <div v-if="alertMissingList.length === 0" class="text-center py-3">
      <h4>{{ $t("navigations.no data found") }}</h4>
      </div>
      <div v-else class="table-responsive mt-2 scrollable">
      <table class="table table-bordered table-sm">
        <thead>
        <tr>
          <th>{{ $t("navigations.site code") }}</th>
          <th>{{ $t("navigations.subject id") }}</th>
          <th>{{ $t("navigations.type") }}</th>
          <th>{{ $t("navigations.status") }}</th>
          <th>{{ $t("navigations.view") }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in alertMissingList" :key="item.id">
          <td>{{ item.siteCode }}</td>
          <td>{{ item.subjectCode }}</td>
          <td>{{ item.alertConfig && item.alertConfig.AlertType }}</td>
          <td>{{ item.status }}</td>
          <td class="text-center">
          <i
            class="fa fa-eye editicon align-middle"
            @click="viewAlertDetails(item.id, 'active alerts')"
          ></i>
          </td>
        </tr>
        </tbody>
      </table>
      </div>
    </template>
    <template #footer> </template>
  </customModal>
  <customModal
   v-if="showOutRange == true"
   :containersm="true"
   :footerShow="true"
   @closeModal="CloseAlertRangeList"
  >
   <template #title>
    {{ $t("navigations.out of range") }}
   </template>
   <template #body>
    <div class="table-responsive mt-2 scrollable">
    <table class="table table-bordered table-sm">
      <thead>
      <tr>
       <th>{{ $t("navigations.site code") }}</th>
       <th>{{ $t("navigations.subject id") }}</th>
       <th>{{ $t("navigations.type") }}</th>
       <th>{{ $t("navigations.status") }}</th>
       <th>{{ $t("navigations.view") }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in alertOutRange" :key="item.id">
       <td>{{ item.siteCode }}</td>
       <td>{{ item.subjectCode }}</td>
       <td>{{ item.alertConfig && item.alertConfig.AlertType }}</td>
       <td>{{ item.status }}</td>
       <td class="text-center">
        <i
          class="fa fa-eye editicon align-middle"
          @click="viewAlertDetails(item.id, 'active alerts')"
        ></i>
       </td>
      </tr>
      </tbody>
    </table>
    </div>
   </template>
   <template #footer> </template>
  </customModal>
   
  
   
   <!-- View Alert Details popup starts -->
  <viewAlertDetailsPopup
    v-if="showAlertDetailsPopup"
    ref="viewPopup"
    :AlertId="alertId"
    :AlertType="alertType"
    @openQueryPopup="Openquerypopup(alertId)"
    @callViewModal="openAlertStatusPopup($event)"
    @closeModal="closeAlertDetailsPopup"
  />
  
  <!-- Approve status popup starts -->
  <AlertStatusPopup
    v-if="showAlertStatusPopup"
    :Id="alertId"
    @closemodal="closeAlertStatusPopup"
  />
  <!-- Approve status popup ends -->

  <!-- View Alert Details popup ends -->
   <!-- openquerypopup starts -->
    <customModal
    v-if="querypopup == true"
    ref="listPopupRef"
    :containermd="true"
    :bodymd="
      subjectActivityList && subjectActivityList.length > 10 ? true : false
    "
    @queryAlertCount="querycount()"
    @closeModal="Closequerypopup()"
    
  >
    <template #title>
      Queries
    </template>
    <template #body>
      <div class="text-center">
        <div v-if="!showContent">
          <div class="text-center">
            <h4>{{ $t("navigations.no queries found") }}</h4>
          </div>
        </div>
        <div v-if="showloader" class="spinner-overlay">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
        <div v-else-if="showContent" class="table-responsive scrollable" > 
          <table class="tableFixHead table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th>{{ $t("navigations.query id") }}</th>
                <th>{{ $t("navigations.query subject") }}</th>
                <th>{{ $t("navigations.query status") }}</th>
                <th>{{ $t("navigations.field name") }}</th>
                <th>{{ $t("navigations.view") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="query in Querydetails" :key="query.id">
                <td>{{ query.queryId }}</td>
                <td>{{ query.query_Subject }}</td>
                <td>{{ query.queryOpenStatus }}</td>
                <td>{{ query.fieldName }}</td>
                <td class="tdtext">
                  <a href="#" class="editicon"><i class="fa fa-eye" @click.prevent="viewforms(query.id)"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- test -->
      </div>
      
    </template>
  </customModal>
    <viewAlertQueryPopup
    v-if="showQueryAlertPopup"
    :queryid="queryid"
    @closeQuery="showQueryAlertPopup=false"
    :closedoption="closedoption"
    @applychanges="applychanges($event)"
  />
  <!-- openquerypopup ends -->
</template>
<script src="./alerts.js"></script>

<style scoped>
.max-h-400 {
  max-height: 400px;
  overflow-y: scroll;
}

.alert-badge-primary {
  background-color: #1ab394;
  color: #ffffff;
}
.header {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.scrollable {
  overflow-y: scroll;
  height: 350px;
  background-color: #ffffff;
}
.card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}
.card h5{
  font-size: 16px;
  font-weight:600;
}
.card:hover {
  transform: translateY(-5px);
}

.table th {
  font-weight: 600;
  color: #495057;
  background-color: #f8f9fa;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  line-height: 1.42857;
  padding: 4px;
  white-space: nowrap;
  vertical-align: top;
}

.table-hover tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.05);
}

.badge {
  font-weight: 500;
  padding: 0.5em 0.8em;
}

.progress {
  background-color: #e9ecef;
}

.cursor-pointer {
  cursor: pointer;
}

.alert {
  border-left: 4px solid;
  margin-bottom: 4px !important;
}

.alert-badge {
  padding: 1px 10px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.badge-pending {
  background-color: rgba(248, 172, 89, 0.15);
  color: var(--warning);
}

.badge-resolved {
  background-color: rgba(28, 132, 198, 0.15);
  color: var(--success);
}

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.status-pending {
  background-color: var(--warning);
}

.status-resolved {
  background-color: var(--success);
}

.time-elapsed {
  font-weight: 600;
  color: var(--warning);
}

.alert-row {
  transition: background-color 0.3s ease;
}

.alert-row:hover {
  background-color: rgba(26, 179, 148, 0.05);
}

.alert-type-badge {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
}

.vital-badge {
  background-color: rgb(207, 244, 252);
  color: rgb(5, 81, 96);
}

.lab-badge {
  background-color: rgba(35, 198, 200, 0.15);
  color: var(--secondary);
}

.med-badge {
  background-color: rgba(28, 132, 198, 0.15);
  color: var(--success);
}

.other-badge {
  background-color: rgba(149, 165, 166, 0.15);
  color: #95a5a6;
}

.notification-preview {
  background-color: #f8f9fa;
  border-radius: 3px;
  padding: 15px;
  border-left: 4px solid var(--warning);
  margin-top: 20px;
  font-size: 0.9rem;
}
.rounded-two {
  border-radius: 0rem 2.25rem 2.25rem 0rem !important;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 12px;
  text-align: left;
  padding: 4px 4px;
  position: sticky !important;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #e2e8f0;
}

.data-table td {
  padding: 4px 4px;
  font-size: 12px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.data-table tr:hover td {
  background: #f8fafc;
}
.custom-alert-info {
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
}
.spinner-overlay {
  position:relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
</style>
